import { gql } from "@apollo/client";

const INTERACTION_FIELDS = `
  _id
  linkedReference {
    collection
    documentId
    documentName
    documentType
    isLead
  }
  summary
  communicationMethod
  interactionDate
  createdBy { _id firstName lastName }
  updatedBy { _id firstName lastName }
  createdAt
  meta { isDeleted testData }
`;

export const FIND_INTERACTIONS = gql`
  query FindInteractions($linkedReference: InteractionLinkedReferenceInput, $page: Int, $pageSize: Int) {
    findInteractions(linkedReference: $linkedReference, page: $page, pageSize: $pageSize) {
      ${INTERACTION_FIELDS}
    }
  }
`;

export const FIND_INTERACTION_BY_ID = gql`
  query FindInteractionById($_id: ID!) {
    findInteractionById(_id: $_id) {
      ${INTERACTION_FIELDS}
    }
  }
`;

export const FIND_INTERACTIONS_BY_LINKED_REFERENCE = gql`
  query FindInteractionsByLinkedReference($linkedReference: InteractionLinkedReferenceInput!, $limit: Int) {
    findInteractionsByLinkedReference(linkedReference: $linkedReference, limit: $limit) {
      _id
      summary
      communicationMethod
      interactionDate
      createdBy {
        _id
        firstName
        lastName
      }
    }
  }
`;
